<template functional>
    <div class="top-section" :class="data.staticClass">
        <slot name="header-wrapper">
            <h2 class="section-header text-uppercase top-section__header">
                <slot name="header"> </slot>
            </h2>
        </slot>

        <p v-if="slots().text" class="section-text">
            <slot name="text"> </slot>
        </p>

        <slot> </slot>
    </div>
</template>

<script>
export default {
    name: 'TopSection'
};
</script>

<style lang="scss" scoped>
.top-section {
    .section-header {
        font-size: 17px;
        font-weight: bold;
    }

	&__header {
		color: var(--primary-accessible, var(--primary))
	}

    .section-header:last-child,
    .section-text:last-child {
        margin-bottom: 0;
    }
}
</style>
